// SecondSection.js - Modern Amenities Component
import React from 'react';
import { GiTowel } from "react-icons/gi";
import { FaCar } from "react-icons/fa";
import { PiTelevisionSimpleBold } from "react-icons/pi";
import { FaBath } from "react-icons/fa";
import { FaKitchenSet } from "react-icons/fa6";
import { SiNetflix } from "react-icons/si";
import { FaShower } from "react-icons/fa";
import { TbFridge } from "react-icons/tb";
import { FaWifi } from "react-icons/fa";
import { TbAirConditioning } from "react-icons/tb";
import { FaBicycle } from "react-icons/fa";

const icons = [
    { icon: GiTowel, label: 'Towels', name: 'towels', color: '#10c9c0' },
    { icon: FaCar, label: 'Car', name: 'car', color: '#e74c3c' },
    { icon: PiTelevisionSimpleBold, label: 'TV', name: 'tv', color: '#3498db' },
    { icon: FaBath, label: 'Bath', name: 'bath', color: '#9b59b6' },
    { icon: FaKitchenSet, label: 'Kitchen', name: 'kitchen', color: '#f39c12' },
    { icon: SiNetflix, label: 'Netflix', name: 'netflix', color: '#e50914' },
    { icon: FaShower, label: 'Shower', name: 'shower', color: '#1abc9c' },
    { icon: TbFridge, label: 'Fridge', name: 'fridge', color: '#34495e' },
    { icon: FaWifi, label: 'WiFi', name: 'wifi', color: '#2ecc71' },
    { icon: TbAirConditioning, label: 'AC', name: 'ac', color: '#3498db' },
    { icon: FaBicycle, label: 'Bicycle', name: 'bicycle', color: '#27ae60' },
];

function SecondSection({ data }) {
    const availableAmenities = icons.filter(item => data.amenities.includes(item.name));
    
    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Available Amenities</h3>
                <p className="text-base md:text-lg font-light text-[#949995]">Everything you need for a comfortable stay</p>
            </div>
            
            {/* Amenities Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {availableAmenities.map((item, index) => (
                    <div 
                        key={index}
                        className="group relative bg-white rounded-2xl p-6 shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                    >
                        <div className="flex flex-col items-center text-center space-y-3 relative z-10">
                            <div 
                                className="w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-300 group-hover:scale-110"
                                style={{ backgroundColor: `${item.color}15` }}
                            >
                                <item.icon 
                                    className="text-3xl transition-all duration-300"
                                    style={{ color: item.color }}
                                />
                            </div>
                            <p className="text-gray-700 font-semibold text-lg group-hover:text-gray-900 transition-colors duration-300">
                                {item.label}
                            </p>
                        </div>
                        
                        {/* Hover effect background */}
                        <div 
                            className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-5 transition-opacity duration-300 pointer-events-none"
                            style={{ backgroundColor: item.color }}
                        ></div>
                    </div>
                ))}
            </div>
            
            {/* No amenities message */}
            {availableAmenities.length === 0 && (
                <div className="text-center py-12">
                    <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2M4 13h2m13-4v4H7V9h10z" />
                        </svg>
                    </div>
                    <p className="text-gray-500 text-lg">No amenities information available</p>
                </div>
            )}
        </div>
    );
}


export default SecondSection;

